import { Textarea } from '../ui/textarea'

interface ConditionJsonEditorProps {
  value: string
  onChange: (value: string) => void
  error: string | null
}

export function ConditionJsonEditor({ value, onChange, error }: ConditionJsonEditorProps) {
  return (
    <div className="space-y-2">
      <Textarea
        className="font-mono text-sm min-h-[200px]"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="conditions-json-editor"
      />
      {error && (
        <p className="text-sm text-destructive">{error}</p>
      )}
    </div>
  )
}
